module.exports = function getResource(label, vars = []) {
    const resources = {
        defaultCard: 'Carte par défaut',
        expires: 'Expire le',
        payPalAccount: 'Compte PayPal',
        payWithPayPal: 'Payer avec PayPal',
        payWithApplePay: 'Payer avec ApplePay',
        payWithKlarna: 'Payez en quatre versements sans intérêt',
        storeCreditApplied: 'Crédit au compte appliqué',
        endingIn: 'se terminant par',
        klarnaDisabled: 'Klarna ne peut pas être utilisée pour les achats de cartes-cadeaux, de Flash, d’abonnements ou de rendez-vous en magasin, pour les récompenses Carte de crédit Sephora, ni pour les commandes de 1 000 $ ou plus.'
    };

    return resources[label];
};
